import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { useAuth } from "@/contexts/AuthContext";
import { Menu } from "lucide-react";
import { useState } from "react";

const NAV = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/tools", label: "Free tools" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function MarketingLayout() {
  const { user } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="glass-header sticky top-0 z-40 border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-6">
          <Logo />
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/ /g, '-')}`}
                className={({ isActive }) => `px-3 py-2 text-[13.5px] rounded-md transition-colors ${isActive ? 'text-[#0047FF]' : 'text-[#525B6A] hover:text-[#0A0D14]'}`}
              >{n.label}</NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <Link to="/app/overview" data-testid="cta-dashboard" className="btn-primary px-4 py-2 rounded-md text-sm">Open dashboard</Link>
            ) : (
              <>
                <Link to="/login" data-testid="cta-login" className="hidden sm:inline-flex text-sm px-3 py-2 text-[#0A0D14] hover:text-[#0047FF]">Log in</Link>
                <Link to="/signup" data-testid="cta-signup-header" className="btn-primary px-4 py-2 rounded-md text-sm">Start Free Trial</Link>
              </>
            )}
            <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="md:hidden p-2 border border-[#E2E8F0] rounded-md">
              <Menu className="h-4 w-4" />
            </button>
          </div>
        </div>
        {open && (
          <div className="md:hidden border-t border-[#E2E8F0] bg-white px-4 py-2">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-sm text-[#525B6A]">{n.label}</Link>
            ))}
          </div>
        )}
      </header>

      <main className="flex-1" key={loc.pathname}>
        <Outlet />
      </main>

      <footer className="border-t border-[#E2E8F0] bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Logo />
            <p className="mt-4 text-sm text-[#525B6A] max-w-xs leading-relaxed">Simple keyword rank tracking for agencies, freelancers, marketers, and creators. Track with SEO Activity Timeline to know which backlink works.</p>
          </div>
          <div>
            <div className="eyebrow mb-3">Product</div>
            <ul className="space-y-2 text-sm text-[#525B6A]">
              <li><Link to="/features" className="hover:text-[#0047FF]">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-[#0047FF]">Pricing</Link></li>
              <li><Link to="/tools" className="hover:text-[#0047FF]">Free tools</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Company</div>
            <ul className="space-y-2 text-sm text-[#525B6A]">
              <li><Link to="/contact" className="hover:text-[#0047FF]">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-3">Legal</div>
            <ul className="space-y-2 text-sm text-[#525B6A]">
              <li><Link to="/faq" className="hover:text-[#0047FF]">FAQ</Link></li>
              <li><Link to="/terms" className="hover:text-[#0047FF]">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-[#0047FF]">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#E2E8F0]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8A94A6]">
            <div>© {new Date().getFullYear()} SerpNex.</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
